// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2btyk","colMaxWidth":"Table_colMaxWidth__3IYtb"};